import cache from '@/utils/cache'

// 设置当前登录的用户信息
export const SET_LOGIN_USER_INFO = 'SET_LOGIN_USER_INFO'

// 当前登录信息保存到缓存的字段
const STORE__RNR_LOGIN_USER = 'STORE__RNR_LOGIN_USER'

export default {
  namespaced: true,
  state: {
    loginUser: cache.get(STORE__RNR_LOGIN_USER, {})
  },
  mutations: {
    /**
     * 保存当前登录的用户信息
     */
    [SET_LOGIN_USER_INFO](state, payload) {
      state.loginUser = payload
      cache.set(STORE__RNR_LOGIN_USER, state.loginUser)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js